/**
 *		TOGGLE FAVORITE
 *		- Add to Favorites if not already favorited
 *		- Remove from Favorites if already favorited
 */
function toggleFavorite(event) {
	if (dragging) return;

	var target = event.target.closest("[data-favorite]");

	if (target) {

		if(window.loggedIn === false)
		{
			return window.location.replace("/account");
		}

		var entryId = target.dataset.favorite;
		var entryType = target.dataset.type;

		target.classList.toggle("favorited");

		if(window.location.pathname == '/account/my-favorites')
		{
			fadeOutFavorite(target);
		}

		axios.post('/ajax/favorites', {
			'id': entryId,
			'type': entryType
		})
            .then(function (response) {
                if(response.data.action === 'remove')
                {
					target.classList.remove("favorited");
					if(window.location.pathname == '/account/my-favorites')
                    {
						fadeOutFavorite(target);
					}
				}

				if(response.data.action === 'add')
				{
					target.classList.add("favorited");
					if(window.location.pathname == '/account/my-favorites')
					{
						fadeOutFavorite(target);
					}
				}
			})
			.catch(function (error) {
				if(error.response.status === 401)
				{
					return window.location.replace("/account");
				}
			});

		event.preventDefault();
		event.stopPropagation();
	}
}

function fadeOutFavorite(target)
{
	if(target.closest('.homes-listing-detail')) {
		if(target.classList.contains('favorited')) {
			target.closest('.homes-listing-detail').style.opacity = 1;
		}
		else {
			target.closest('.homes-listing-detail').style.opacity = 0.4;
		}
	}

	if(target.closest('.communities-listing-detail')) {
		if(target.classList.contains('favorited')) {
			target.closest('.communities-listing-detail').style.opacity = 1;
		}
		else {
			target.closest('.communities-listing-detail').style.opacity = 0.4;
		}
	}

	if(target.closest('.floor-plans-listing-detail')) {
		if(target.classList.contains('favorited')) {
			target.closest('.floor-plans-listing-detail').style.opacity = 1;
		}
		else {
			target.closest('.floor-plans-listing-detail').style.opacity = 0.4;
		}
	}

	if(target.closest('.media-hub-listing-detail')) {
		if(target.classList.contains('favorited')) {
			target.closest('.media-hub-listing-detail').style.opacity = 1;
		}
		else {
			target.closest('.media-hub-listing-detail').style.opacity = 0.4;
		}
	}
}

document.addEventListener("DOMContentLoaded", function () {
	// Toggle Favorite
	document.addEventListener("click", toggleFavorite);
	document.addEventListener("touchend", toggleFavorite);
});